module.exports = __webpack_public_path__ + "static/media/reply.402b622a.svg";